import { Period } from '@enmon/commons/lib/enmon';

const PERIOD_TRANSLATED: Record<Period, string> = {
  [Period.Custom]: 'Custom',
  [Period.ThisYear]: 'This year',
  [Period.ThisMonth]: 'This month',
  [Period.ThisWeek]: 'This week',
  [Period.PreviousWeek]: 'Previous week',
  [Period.PreviousMonth]: 'Previous month',
  [Period.Last]: 'Last measurement',
  [Period.LastQuarterhour]: 'Last quarterhour',
  [Period.LastHour]: 'Last hour',
  [Period.Yesterday]: 'Yesterday',
  [Period.Last24hours]: 'Last 24 hours',
  [Period.LastDay]: 'Last day',
  [Period.Last7days]: 'Last 7 days',
  [Period.Last30days]: 'Last 30 days',
  [Period.Last3months]: 'Last 3 months',
  [Period.Last6months]: 'Last 6 months',
  [Period.Last12months]: 'Last 12 months',
  [Period.Last24months]: 'Last 24 months',
  [Period.Last36months]: 'Last 36 months',
  [Period.PreviousYear]: 'Previous year',
  [Period.PreviousQuarter]: 'Previous quarter',
};

export const periodOptions = Object.values(Period).map(period => ({
  value: period,
  label: PERIOD_TRANSLATED[period],
}));
